import types from '../../../actions/types';
import {takeEvery, all, put} from 'redux-saga/effects';
import {handleFormSubmit} from '../../../sagas/common-sagas';
import {storeToken} from '../../../utils/local-storage';
import {getCurrentUser} from '../../../actions/user-actions';
import {push} from 'react-router-redux';

function* loginSaga(action) {
    yield handleFormSubmit('/api/auth/', action, types.LOGIN);
}

function* loginSuccess(action) {
    storeToken(action.payload.token);
    yield put(getCurrentUser());
    yield put(push('/'));
}

export default function* loginSagas() {
    yield all([
        takeEvery(types.LOGIN.REQUEST, loginSaga),
        takeEvery(types.LOGIN.SUCCESS, loginSuccess),
    ]);
}



// WEBPACK FOOTER //
// ./src/js/routes/login/modules/login-sagas.js